"use client";
import QRCode from "react-qr-code";
import { ModalCustom } from "../../../components/custom/modal-custom";
import {
  EQUIPMENT_STATUS_NAME,
  EQUIPMENT_TYPE_NAME,
} from "../services/equipment-service";
import { EquipmentRow } from "./equipment-table";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: EquipmentRow | null;
}

/** ISO / "YYYY-MM-DD HH:mm:ss" → "dd/MM/yyyy HH:mm" (giờ địa phương). */
const formatDateTime = (raw?: string | null): string => {
  if (!raw) return "—";
  const s = String(raw);
  const d = new Date(s.includes("T") || s.endsWith("Z") ? s : s.replace(" ", "T") + "Z");
  if (isNaN(d.getTime())) return s;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

const DetailItem = ({ label, value }: { label: string; value?: string | number | null }) => (
  <div className="flex border-b py-2">
    <span className="w-40 text-sm font-medium text-gray-600">{label}</span>
    <span className="text-sm text-gray-900 flex-1">{value ?? "—"}</span>
  </div>
);

const EquipmentDetailModal: React.FC<Props> = ({ isOpen, onClose, data }) => {
  if (!data) return null;

  const bodyModal = (
    <div className="space-y-1">
      {/* QR Code */}
      <div className="flex justify-center py-4 mb-2">
        <div className="bg-white p-3 rounded-lg shadow-sm border inline-block">
          <QRCode
            value={data.code}
            size={150}
            bgColor="#ffffff"
            fgColor="#000000"
            level="M"
          />
        </div>
      </div>
      <DetailItem label="Mã thiết bị" value={data.code} />
      <DetailItem label="Tên thiết bị" value={data.name || "—"} />
      <DetailItem label="Loại" value={EQUIPMENT_TYPE_NAME[data.type]} />
      <DetailItem label="Trạng thái" value={EQUIPMENT_STATUS_NAME[data.status]} />
      <DetailItem label="Sức chứa (kg)" value={data.capacity} />
      <DetailItem label="Đơn hiện tại" value={data.current_order_id ? `#${data.current_order_id}` : "Không có"} />
      <DetailItem label="Ghi chú" value={data.note} />
      <DetailItem label="Ngày tạo" value={formatDateTime(data.created_at)} />
    </div>
  );

  const footerModal = (
    <button
      type="button"
      onClick={onClose}
      className="px-4 py-2 text-sm border rounded hover:bg-gray-50"
    >
      Đóng
    </button>
  );

  return (
    <ModalCustom
      titleModal="Chi tiết thiết bị"
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyModal={bodyModal}
      footerModal={footerModal}
      modalSize="lg"
    />
  );
};

export default EquipmentDetailModal;
